<template>
  <div class="mobile">
    <img
      class="personalbg"
      src="../../../static/images/mobile/backgroudg.png"
      alt=""
    />
    <!-- 搜索框 -->
    <van-search
      class="homeSearchPlaceholder"
      @focus="searchResult"
      placeholder="搜索课程"
    />
    <!-- 下拉刷新 -->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!--推荐课程轮播图-->
      <van-swipe
        class="my-swipe indexRefresh"
        :autoplay="3000"
        indicator-color="white"
      >
        <van-swipe-item
          ><img src="../../../static/images/mobile/banner.png" width="100%"
        /></van-swipe-item>
      </van-swipe>
      <!-- 宫格 -->
      <div class="classification">
        <div class="my-swipes">
          <van-swipe
            class="my-swipe"
            :autoplay="3000"
            indicator-color="#dc0021"
          >
            <van-swipe-item
              v-for="(list, index) in fristLevelColumn"
              :key="index"
            >
              <van-grid>
                <van-grid-item
                  @click="mobileCourseList"
                  v-for="list in list"
                  :key="list.id"
                  :icon="list.appPictureUrlShow"
                  :text="list.name"
                />
              </van-grid>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="classAll">
          <van-grid class="classAll-box">
            <van-grid-item
              @click="mobileCourseList"
              icon="../../../static/images/mobile/classification.png"
              text="全部分类"
            />
          </van-grid>
        </div>
      </div>
      <div class="class-title">精选推荐</div>
      <div class="mobile-hot">
        <ul>
          <li
            v-for="list in hotGoods"
            :key="list.id"
            @click="goToGoodsDetails(list.id)"
          >
            <img :src="list.goodsPic" />
            <h5 class="mobile-hot-title">【视频】{{ list.goodsName }}</h5>
            <span v-if="list.categoryName" class="classify fl">{{
              list.categoryName
            }}</span>
            <div style="margin-top: 0.24rem">
              <span class="period">{{ list.testHours }}学时 </span>
              <span
                class="classPrice fr"
                style="color: #dc0021; font-weight: 400"
                >￥{{ list.platformPrice }}</span
              >
            </div>
          </li>
        </ul>
      </div>
    </van-pull-refresh>
    <van-tabbar v-model="active">
      <van-tabbar-item to="/mobileHome">
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? index.active : index.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/mobileStudy">
        <span>班级</span>
        <template #icon="props">
          <img :src="props.active ? classes.active : classes.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/mobileMy">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? my.active : my.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
import MescrollVue from "mescroll.js/mescroll.vue";
import "../../js/baiducount.js";
import { Toast } from "vant";
export default {
  data() {
    return {
      isLoading: false,
      active: 0,
      fristLevelColumn: [],
      referrerCarouselGoods: [],
      //广告位之前,两个推荐课程
      topAdvertTwoGoods: [],
      //中间三个推荐课程
      middleAdvertThreeGoods: [],
      //热门课程
      hotGoods: [],
      show: true,
      count: 0,
      dataList: [], // 列表数据
      index: {
        active: "../../../static/images/mobile/onIndex.png",
        inactive: "../../../static/images/mobile/index.png",
      },
      classes: {
        active: "../../../static/images/mobile/onClass.png",
        inactive: "../../../static/images/mobile/class.png",
      },
      my: {
        active: "../../../static/images/mobile/onMy.png",
        inactive: "../../../static/images/mobile/my.png",
      }, //table栏
    };
  },
  components: {
    Swipe,
    SwipeItem,
    MescrollVue,
  },
  methods: {
    //判断是否登录
    judgeLogin() {
      if (this.$sessionStore.getUserId()) {
        return true;
      } else {
        return false;
      }
    },
    initFristLevelColumn: function () {
      this.$axiosPackag.getMessageByAxios(
        "POST",
        "/goodsCategory/listCategory",
        { pid: 0 },
        null,
        null,
        (successCallResult) => {
          if (successCallResult && successCallResult.count > 0) {
            let categoryList = successCallResult.categoryList;
            if (categoryList) {
              var result = [];
              for (var i = 0; i < categoryList.length; i += 3) {
                result.push(categoryList.slice(i, i + 3));
                this.fristLevelColumn = result;
              }
            }
          }
        },
        (errorCall) => {}
      );
    },
    initReferrerCarouselGoods: function () {
      this.$axiosPackag.getMessageByAxios(
        "GET",
        "/web/findColumnRecommendGoods/H5LB/3",
        null,
        null,
        null,
        (successCallResult) => {
          if (successCallResult && successCallResult.total > 0) {
            let array = [];
            successCallResult.rows.forEach(function (item, index) {
              let columnItem = {};
              columnItem.id = item.id;
              columnItem.goodsPic = item.goodsPic;
              columnItem.goodsName = item.goodsName;
              array.push(columnItem);
            });
            this.referrerCarouselGoods = array;
          }
        },
        (errorCall) => {}
      );
    },
    selectDynamicGoods: function (dynamicSize, callBcakFunction) {
      this.$axiosPackag.getMessageByAxios(
        "GET",
        "/web/findColumnRecommendGoods/H5INDEX/" + dynamicSize,
        null,
        null,
        null,
        (successCallResult) => {
          if (successCallResult && successCallResult.total > 0) {
            let array = [];
            let _this = this;
            successCallResult.rows.forEach(function (item, index) {
              let columnItem = {};
              columnItem.id = item.id;
              columnItem.goodsPic = item.goodsPic;
              columnItem.goodsName = item.goodsName;
              if (!_this.$util.isBlackStr(item.goodsDesc)) {
                let textDesc = _this.$util.html(item.goodsDesc);
                textDesc = _this.$util.filterHtmlTag(textDesc);
                if (!_this.$util.isBlackStr(textDesc)) {
                  if (textDesc.length > 30) {
                    textDesc = textDesc.substr(0, 30);
                  }
                  columnItem.goodsDesc = "  " + textDesc;
                }
              }
              columnItem.isFree = item.isFree === 0;
              columnItem.testHours = item.testHours;
              let categoryInfoList = item.categoryInfoList;
              if (categoryInfoList && categoryInfoList.length > 0) {
                columnItem.categoryName = categoryInfoList[0].name;
              }
              array.push(columnItem);
            });
            callBcakFunction(array, successCallResult.total);
          }
        },
        (errorCall) => {}
      );
    },
    selectTopAdvertTwoGoods: function () {
      let _this = this;
      this.selectDynamicGoods(2, function (array, total) {
        _this.topAdvertTwoGoods = array;
      });
    },
    selectMiddleAdvertThreeGoods: function () {
      let _this = this;
      this.selectDynamicGoods(3, function (array, total) {
        if (total && total > 2) {
          //刷出来新的课程了
          _this.middleAdvertThreeGoods = array;
        }
      });
    },
    selectHotGoods: function () {
      this.$axiosPackag.getMessageByAxios(
        "GET",
        "/web/getMaxSalesGoods/10",
        null,
        null,
        null,
        (successCallResult) => {
          if (successCallResult) {
            let array = [];
            let _this = this;
            successCallResult.forEach(function (item, index) {
              let columnItem = {};
              columnItem.id = item.id;
              columnItem.goodsPic = item.pictureShowUrl;
              columnItem.goodsName = item.goodsName;
              columnItem.platformPrice = item.platformPrice;
              if (!_this.$util.isBlackStr(item.goodsDesc)) {
                let textDesc = _this.$util.html(item.goodsDesc);
                textDesc = _this.$util.filterHtmlTag(textDesc);
                if (!_this.$util.isBlackStr(textDesc)) {
                  if (textDesc.length > 30) {
                    textDesc = textDesc.substr(0, 30);
                  }
                  columnItem.goodsDesc = "  " + textDesc;
                }
              }
              columnItem.isFree = item.isFree === 0;
              columnItem.testHours = item.testHours;
              let categoryInfoList = item.testHours;
              if (categoryInfoList && categoryInfoList.length > 0) {
                columnItem.categoryName = categoryInfoList[0].name;
              }
              array.push(columnItem);
            });
            this.hotGoods = array;
          }
        },
        (errorCall) => {}
      );
    },
    changeCategory(categoryId, categoryName) {
      if (categoryId == 0) {
        this.active = categoryId;
      } else {
        this.$router.push({
          path: "/mobileCategory",
          query: { categoryId: categoryId, categoryName: categoryName },
        });
      }
    },
    goToEpidemic() {
      this.$router.push({ path: "/mobileClassRoom" });
    },
    closeWin() {
      var browserName = navigator.appName;
      var browserVer = parseInt(navigator.appVersion);
      if (browserName == "Microsoft Internet Explorer") {
        var ie7 =
          document.all && !window.opera && window.XMLHttpRequest ? true : false;
        if (ie7) {
          //This method is required to close a window without any prompt for IE7 & greater versions.
          window.open("", "_parent", "");
          window.close();
        } else {
          //This method is required to close a window without any prompt for IE6
          this.focus();
          self.opener = this;
          self.close();
        }
      } else {
        //For NON-IE Browsers except Firefox which doesnt support Auto Close
        try {
          this.focus();
          self.opener = this;
          self.close();
        } catch (e) {}
        try {
          window.open("", "_self", "");
          window.close();
        } catch (e) {}
        try {
          window.open(location, "_self").close();
        } catch (e) {}
      }
      //移动端的
      try {
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
        if (isiOS) {
          //公众号关闭
          WeixinJSBridge.call("closeWindow");
        } else if (isAndroid) {
          //公众号关闭
          document.addEventListener(
            "WeixinJSBridgeReady",
            function () {
              WeixinJSBridge.call("closeWindow");
            },
            false
          );
        }
      } catch (e) {}
    },
    onRefresh() {
      setTimeout(() => {
        Toast("刷新成功");
        this.isLoading = false;
      }, 1000);
    },
    goToGoodsDetails: function (goodsId) {
      this.$router.push({
        path: "/mobileCourseDetail",
        query: { id: goodsId, classNums: true, actives: 0 },
      });
    },
    //跳转搜索页
    searchResult() {
      this.$router.push({ path: "/mobileSearchResult" });
    },
    //跳转全部课程列表页
    mobileCourseList() {
      this.$router.push({ path: "/mobileCourseList" });
    },
    // //跳转课程列表页
    // mobileCourseLists(sort) {
    // 	this.$router.push({ path: "/mobileCourseList", query: { activeKey: sort }  });
    // },
  },
  created: function () {
    // this.noticeOneDayExsist();
  },
  mounted() {
    this.initFristLevelColumn();
    this.initReferrerCarouselGoods();
    this.selectTopAdvertTwoGoods();
    this.selectMiddleAdvertThreeGoods();
    this.selectHotGoods();
  },
  computed: {},
};
</script>

<style>
.homeSearchPlaceholder .van-field__body .van-field__control::placeholder {
  color: #fff;
}
.homeSearchPlaceholder .van-field__body {
  margin: 0.16rem 0.16rem 0.16rem 0.32rem;
}
.homeSearchPlaceholder .van-field__left-icon {
  margin: 0.16rem 0 0.16rem 0;
}
.classification .my-swipe .van-swipe__indicators {
  left: 70% !important;
  bottom: 0;
}
.classification .my-swipe .van-swipe__indicators .van-swipe__indicator--active {
  width: 0.4267rem;
  height: 0.1333rem;
  opacity: 1;
  border-radius: 0.08rem;
}
[class*="van-hairline"]::after {
  border: none;
}
</style>
<style scoped>
.classification {
  display: flex;
  justify-content: center;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 0.266667rem;
  line-height: 2rem;
  text-align: center;
}
.my-swipe .van-grid-item {
  flex-basis: 33% !important;
}
.my-swipes {
  width: 6.853333rem;
  height: 1.893333rem;
}
.classAll {
  display: block;
  width: 2.24rem;
  height: 1.893333rem;
}
.classAll-box {
  display: block !important;
}
.closePerson {
  position: absolute;
  height: 0.4rem;
  height: 0.4rem;
  left: 0.4rem;
  top: 0.4rem;
}
.mescroll {
  position: fixed;
  top: 2.32rem;
  bottom: 0;
  height: auto;
}
.mobile-header a {
  overflow: hidden;
  display: inline-block;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: auto;
}
.mobile-header a span {
  display: flex;
}
.mobile-header {
  display: flex;
  align-items: center;
}
.tcWrap {
  width: 6.8rem;
}
.tcTitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 0.2rem;
  letter-spacing: 0.026667rem;
  font-size: 0.36rem;
}
.tcWrap p {
  font-size: 0.24rem;
  margin: 0.26rem 0;
  text-align: justify;
}
.spanRed {
  color: red;
}
.tcDepartment {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
}
.readBtn {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 0.3rem;
}
.class-title {
  font-size: 0.426667rem;
  font-weight: bold;
  margin-left: 0.426667rem;
  padding-top: 1.6rem;
}
.mobile-hot-title {
  font-weight: bold;
  font-size: 0.426667rem;
  width: 3.6rem;
  height: 1.173333rem;
  margin-left: 0.426667rem;
}
.mobile-hot {
  margin-bottom: 0.666667rem;
}
.classPrice {
  margin-right: 0.426667rem;
  margin-bottom: 0.4rem;
  font-size: 0.32rem;
}
.personalbg {
	position: absolute;
	width: 100%;
	height: 4.693333rem;
}
.indexRefresh {
  width: 9.146667rem;
  margin: 0 auto;
}
.van-search .van-cell {
  height: 0.853333rem;
  border-radius: 0.48rem;
  background: #ff9c9f;
  padding-left: 0.32rem;
  color: #fff;
}
.van-tabbar-item--active {
  color: #dc0021 !important;
}
.van-search {
  padding-left: 0;
}
.van-swipe__indicators {
  left: 70% !important;
  bottom: 0;
}
</style>


// WEBPACK FOOTER //
// MobileHome.vue?539f30df